import { jsx as t, jsxs as a } from "react/jsx-runtime";
import s from "react";
import { p as _ } from "../../index-B0ARwqly.mjs";
import { classes as n } from "../../utils/helpers.js";
import '../../assets/SectionedContent.css';const i = "_h2_16wib_6", l = "_h3_16wib_6", p = "_h4_16wib_6", d = "_h5_16wib_6", m = "_h6_16wib_6", o = {
  "sectioned-content__content": "_sectioned-content__content_16wib_1",
  h2: i,
  h3: l,
  h4: p,
  h5: d,
  h6: m
};
function g({ sections: c = [] }) {
  const h = /* @__PURE__ */ new Map([
    ["primary", {
      open: `<h1 class="${n(["h2", o.h2])}">`,
      close: "</h1>"
    }],
    ["secondary", {
      open: `<h2 class="${n(["h3", o.h3])}">`,
      close: "</h2>"
    }]
  ]);
  return /* @__PURE__ */ t("sectioned-content", { children: c.length && c.map((e, r) => e.content !== "" ? /* @__PURE__ */ a(s.Fragment, { children: [
    _(h.get(e.header.type).open + e.header.title + h.get(e.header.type).close),
    /* @__PURE__ */ t("div", { className: n([o["sectioned-content__content"], "sectioned-content__content"]), children: typeof e.content == "string" ? _(e.content) : e.content })
  ] }, `section-${e.title}-${r}`) : /* @__PURE__ */ t(s.Fragment, {}, `section--${r}`)) });
}
export {
  g as SectionedContent,
  g as default
};
